import { useState } from 'react';
import { Pagination, SelectOption, TextField } from '@tryhackme/thm-ui-components';
import { faFileCertificate } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { StyledLoading, StyledLoadingPagination } from 'src/common/components';
import { SORT_BY } from './certificates.constants';
import { StyledCertificatesSection, StyledFiltersWrapper, StyledLoadingCard, StyledNoCertificates } from './certificates.styles';
import { CertificateItem } from './components';
import { useGetUserCertificatesListQuery } from './certificates-tab.slice';
import { CertificatesSort } from './certificates.types';
export const CertificatesTab = () => {
  const [selectedCertificatesSort, setSelectedCertificatesSort] = useState<SelectOption | undefined>();
  const [currentPage, setCurrentPage] = useState(1);
  const {
    data,
    isFetching
  } = useGetUserCertificatesListQuery({
    sort: ((selectedCertificatesSort?.value ?? SORT_BY[0]?.value) as CertificatesSort),
    page: currentPage
  });
  const certificateList = data?.data?.docs ?? [];
  const totalPages = data?.data?.totalPages;
  // Remove when is integrated in the api
  const isProfessionalCert = false;
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };
  return <StyledCertificatesSection data-sentry-element="StyledCertificatesSection" data-sentry-component="CertificatesTab" data-sentry-source-file="certificates-tab.tsx">
      <StyledFiltersWrapper data-sentry-element="StyledFiltersWrapper" data-sentry-source-file="certificates-tab.tsx">
        {/* to be fill it  when filters are ready */}
        <div />

        <TextField id="s" variant="select" label="Sort by" isMulti={false} isSearchable={false} selected={selectedCertificatesSort ?? SORT_BY[0]} defaultValue={selectedCertificatesSort} handleSelection={setSelectedCertificatesSort} options={SORT_BY} labelPosition="left" data-sentry-element="TextField" data-sentry-source-file="certificates-tab.tsx" />
      </StyledFiltersWrapper>

      {isFetching && <>
          <StyledLoadingCard height="12.6rem" />
          <StyledLoadingCard height="12.6rem" />
          <StyledLoadingCard height="12.6rem" />
        </>}
      <ul>
        {!isFetching && certificateList && certificateList.length === 0 ? <StyledNoCertificates>
            <FontAwesomeIcon icon={faFileCertificate} />
            <p>You have not earned or generated a certificate yet.</p>
            <Link to="/">Learn more</Link>
          </StyledNoCertificates> : certificateList?.map(certificate => <CertificateItem isProfessionalCert={isProfessionalCert} key={certificate._id} name={certificate.title ?? certificate.name} achieved={certificate.achieved} url={certificate.url} certId={certificate.certId} />)}
      </ul>
      {isFetching && <StyledLoadingPagination>
          <StyledLoading width="24.4rem" height="3.6rem" />
          <StyledLoading width="30rem" height="1.4rem" />
        </StyledLoadingPagination>}

      {!isFetching && totalPages && totalPages > 1 && <Pagination totalPages={totalPages} selectedPage={currentPage} onChange={handlePageChange} />}
    </StyledCertificatesSection>;
};